import { useContext } from "react";
import { MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import { OeeSummaryDashboardContext } from "contexts/OeeSummaryDashboardContext/OeeSummaryDashboardContext";
import useDateFormat from "hooks/useDateFormat";
import { OEE_DATE_PRESETS, OeeDatePresetEnum, formatOeeDateRangeLabel } from "utilities/oeeDateRange";
import { useStyles } from "./OeeDateRangePreset.styles";

const OeeDateRangePreset = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { getDateFormatByLanguage } = useDateFormat();
    const { datePreset, dateRange, handleDatePresetChange } = useContext(OeeSummaryDashboardContext);

    const handleChange = (event: SelectChangeEvent<OeeDatePresetEnum>) => {
        handleDatePresetChange(event.target.value as OeeDatePresetEnum);
    };

    return (
        <div className={classes.reportSelectWrapper}>
            <Typography variant="subtitle2" className={classes.inputLabel}>
                {t("locations.summary_report.filters.select_date_range").toUpperCase()}
            </Typography>
            <div className={classes.selectRow}>
                <Select
                    IconComponent={KeyboardArrowDownIcon}
                    className={classes.select}
                    value={datePreset}
                    onChange={handleChange}
                >
                    {OEE_DATE_PRESETS.map((preset) => (
                        <MenuItem key={preset} value={preset} className={classes.menuItem}>
                            {t(`locations.oee_summary_dashboard.date_presets.${preset}`)}
                        </MenuItem>
                    ))}
                </Select>
                <Typography variant="body2" className={classes.dateRangeLabel}>
                    {formatOeeDateRangeLabel(dateRange, getDateFormatByLanguage())}
                </Typography>
            </div>
        </div>
    );
};

export default OeeDateRangePreset;
